.rowInfo {
  padding: 16px 0 10px;
}

.sectionIntro {
  font-size: 13.5px;
  color: var(--muted);
  line-height: 1.55;
  margin: 4px 0 20px;
}

.copyRow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 4px 0 24px;
}

.copyBtn {
  display: inline-flex;
  align-items: center;
  padding: 7px 16px;
  background: white;
  color: var(--ink);
  border: 1.5px solid var(--border);
  border-radius: 20px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: border-color .15s, background .15s, color .15s;
}

.copyBtn:hover {
  border-color: var(--blue);
  color: var(--blue);
  background: var(--blue-lt);
}

.copyHint {
  font-size: 12.5px;
  color: var(--muted2);
  line-height: 1.5;
}
